import React, {useState, useEffect, useContext} from 'react'
import {Box, Card, CardContent, IconButton, LinearProgress, TextField,
  FormControl, InputLabel, Select, MenuItem, Grid, Tooltip, FormControlLabel,
  Checkbox,
  Button,
  Typography
} from '@material-ui/core';
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { makeStyles } from '@material-ui/core/styles'
import SearchIcon from '@material-ui/icons/Search';
import axios from 'axios';
import qs from 'qs';
import {useHistory} from "react-router-dom";
import {ErrorGeneral, llamaApiCargaToken,llamadaApiToken} from '../funciones/ClienteAxios';
import TablaSeguro from './TablaSeguro';
import moment from 'moment';
import TablaArchivos from './TablaArchivos';
//import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
//import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toast } from 'react-toastify';
//import esLocale from "date-fns/locale/es";
import 'moment/locale/es';
import Relojes from './Relojes';
import TablaMaquinaria from './TablaMaquinaria';
import {findNumberCad} from '../funciones/FindNumber'
import ModalNvoAseguradra from './NvoEditAseguradora'
import MenuTab from './MenuTab';
const locale = 'es-ES';
const useStyles = makeStyles((theme) => ({  
      root: {
          minWidth: 275,
      },    
      title: {
          fontSize: 28,
      },
      title2: {
          fontSize: 18,
      },
      subTitle2: {
          fontSize: 12,
      },
      pos: {
      marginBottom: 12,
      },
      addButton: {
          marginRight: theme.spacing(1),       
      },
      altura2: {
          //height: 70,
          //width:'100%',
          margin:0,
          padding:0,
          // width:275
      },   
}));

const Seguro = () => {
  const auxColor=process.env.REACT_APP_COLOR
  const  classes  = useStyles();
  const source = axios.CancelToken.source();
  const history = useHistory();
  const cadena = localStorage.getItem("UserOperacion")+"|"; 
  const hoy=moment(new Date()).format('YYYY-MM-DD')
  const Dispvo =localStorage.getItem('Dispvo') ;    
  const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
  const usuId =localStorage.getItem('UsuId') ;   
  const {usuario, guardarUsuario} = useContext(AuthContext);
  const {guardarGenerales} = useContext(GeneralesContext);
  const [filtro, setFiltro] =  useState({registro:"ANDRES",tipo:"",FIni:hoy, 
    FFin:hoy, Vigente:false, Cadena:"", });
  const [espera, setEspera] = useState(false)
  const [modAsegura, setModAsegura] = useState(false)
  const [esperaArch, setEsperaArch] = useState(false)
  const [esperaMaq, setEsperaMaq] = useState(false)
  const [listTipo,setListTipo]= useState([]) 
  const [listMaquinaria, setListMaquinaria]= useState([]) 
  const [listSeguro, setListSeguro]= useState([]) 
  const [listAseguradora, setListAseguradora]= useState([]) 
  const [datos, setDatos] = useState([])
  const [contrato, setContrato] = useState([])
  const [listArchivos, setListArchivos] = useState([])
  const {registro, tipo, FIni, FFin, Vigente, Cadena}=filtro;
  const [value, setValue] =  useState(hoy);
  const [opcion, setOpcion] =  useState(1);
  const fechMin="1900-01-01T00:00:00"
  useEffect(() => {   

    const veriSesion = () => {
      const usu = localStorage.getItem('UsuarioNom');
      const nvl = localStorage.getItem('Tipo');
      if (usu === null) {
        guardarUsuario([])
        guardarGenerales([])
        localStorage.clear();
        history.push("/")
      } 
      else {
        if (usuario.length === 0) {
          guardarUsuario({Nombre: usu, nivel: nvl});
        }
        getListSeguro()
        getListTipo()
        getListAseguradora()
        guardarGenerales({Titulo: 'Seguro'})          
      }
    }
    veriSesion()
    
    return () => {
      source.cancel();
    }
  }, [ ])

  useEffect(() => {
   
    if (contrato.length!==0) 
    {
      llenarListFile()  
      getListMaquinaria()
    }
  
    return () => {
      source.cancel();
    }
  }, [ contrato])

   const getListSeguro = () => {      
      const data = qs.stringify({
        Usuario:usuId,        
        Tipo:tipo.length!==0 ? tipo: 0,
        Vigente:Vigente ? 1 :  0,
        Cadena:Cadena,
        idDispositivo:auxDispV
      });
      const url = "/maquinaria/seguro/filtro";
      function respuesta(aux) {
        if (aux.length!==0 && aux[0].Id !== -1 && aux[0].Id !== "-1") 
        {   setListSeguro(aux);                
        }  
        else{
          setListSeguro([]);                  
        }
      }
      
      llamadaApiToken(data, url, respuesta,ErrorGeneral,history,source)
    };

  const llenarListFile = () => {      
    let data = qs.stringify({
      Usuario:usuId,
      Seguro:contrato.Id,
      idDispositivo:auxDispV
    });
    let url = "/maquinaria/seguro/file/list";
    function respuesta(aux) {
      if (  aux[0].Id !== -1  ) 
      { setListArchivos(aux);                  
      }
    
    }
          
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEsperaArch, history, source);
  }; 

  const getListMaquinaria = () => {      
    let data = qs.stringify({
      Usuario:usuId,
      Seguro:contrato.Id,
      idDispositivo:auxDispV
    });
    let url = "/maquinaria/seguro/relacion";
    function respuesta(aux) {
      if (  aux[0].Id !== -1  ) 
      { setListMaquinaria(aux);                  
      }
    
    }
          
    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEsperaMaq, history, source);
  }; 

  const getListTipo = () => {    
    const data = qs.stringify({
        Usuario:usuId,                
        idDispositivo: auxDispV
    });
    const url = "/maquinaria/seguro/tipo";

    function respuesta(auxiliar) 
    { 
      if (auxiliar[0].Id !== -1) 
      {                 
        setListTipo(auxiliar)
      }
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  };

  const getListAseguradora = () => {    
    const data = qs.stringify({
        Usuario:usuId,                
        idDispositivo: auxDispV
    });
    const url = "/maquinaria/seguro/aseguradora";

    function respuesta(auxiliar) 
    { 
      if (auxiliar[0].Id !== -1) 
      {                 
        setListAseguradora(auxiliar)
      }
    }

    llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
  };

  const onChangeCheck = (event) => {
    setFiltro({
      ...filtro,
        [event.target.name]: event.target.checked 
      });
  };

  const onChange = e =>
  { let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
      !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
      ||e.target.value===' '||e.target.value==='') 
    {
      setFiltro({
        ...filtro,
        [e.target.name] : e.target.value
      })
    }        
  };

  const onChaneTipo = e =>
  {
    setFiltro({
      ...filtro,
      [e.target.name] : e.target.value  
    })
  };

  const validaFechas=()=>{
    let valor=false
    if (moment(FIni).isValid()) 
    { valor=true  
    }
    else
    { let mensaje="Fecha Inicio incorrecta, escribir una fecha correcta DD/MM/YYYY"        
      toast.warning(`${mensaje}`,{
        pauseOnFocusLoss: false,position:"top-left",
        theme: "colored", toastId: `exito-env`
      })  
    }
    if (moment(FFin).isValid() && !moment(FFin).isBefore("1900-01-01", 'year')) 
    { valor=true  
    }
    else
    { let mensaje="Fecha Final incorrecta, escribir una fecha correcta DD/MM/YYYY"        
      toast.warning(`${mensaje}`,{
        pauseOnFocusLoss: false,position:"top-left",
        theme: "colored", toastId: `exito-env`
      })  
      valor=false
    }
    return valor
  }

  const Buscar=()=>{ 
    getListSeguro() 
 /*    if (validaFechas()) 
    {          
      
      llenaListBusq()    
    }  */
  }

  const menu=()=>{
   return <Box display={"flex"} flexDirection={"row"} mb={2} mt={1}>
    {findNumberCad('|40|',cadena)? 
      <Card style={{padding:0, margin:0, backgroundColor: opcion===1?auxColor:"",
        color: opcion===1?"white":auxColor, width:"6rem", textAlign:"center"
       }} onClick={()=>setOpcion(1)}>
        <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem"}} > Archivos</CardContent>
      </Card>
    :null}
    {findNumberCad('|42|',cadena) ?  
      <Card style={{padding:0, margin:0, backgroundColor: opcion===2?auxColor:"",
        color: opcion===2 ? "white": auxColor, width:"6rem", marginLeft:"1rem",
         textAlign:"center"
       }} onClick={()=>setOpcion(2)}>
        <CardContent style={{padding:0, margin:0, marginTop:".2rem", marginBottom:".2rem"}} > Maquinaria</CardContent>
      </Card>
      :null}
    </Box>
  }

  const Encabezado = ({espacio, estiloCampo, descripcion, campo}) => {
    return (
    <Box {...espacio} >
      <Typography className={classes.title2} variant="h5" color="secondary"
        component="h2" align="center" style={estiloCampo}
      >
        {campo}
      </Typography>
      <Typography className={classes.subTitle2} color="textSecondary" align="center">
        {descripcion}
      </Typography>
    </Box>
    )
  }

  const CampoRenglon = ({estiloBox, estiloTitulo, titulo, campo}) => {
    return (
    <Box  {...estiloBox} >
      <span style={estiloTitulo}>{titulo} </span>
      <Typography variant='body'> {campo}  </Typography>
    </Box>
    )
  }

  const costadoDerecho = (orden) => {
    //let fecha = moment.utc(orden.fecha);
    //let modificada = fecha.local(true).format("DD/MM/YYYY");        
    const colorTitulo = process.env.REACT_APP_COLOR        
    return (
    <span>
      <Box pl={1} my={1} width={"45rem"}>
        <Card  >
          <CardContent>
            <Box display="flex" flexDirection="row" justifyContent="center">
              {/* <Encabezado espacio={{}} estiloCampo={{fontWeight: '900'}} descripcion={"NoEco"} 
                campo={orden.NoEco}/> */}
              <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                descripcion={"Poliza"} campo={orden.Poliza}/>
              {/* <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                  descripcion={"Sección"} campo={orden.seccNom}/> */}
              <Encabezado espacio={{ml: 1}} estiloCampo={{fontWeight: '900'}}
                descripcion={"Aseguradora"} campo={orden.AsegNom}/>                        
            </Box>
            {orden.Descr.length !== 0 && orden.Descr !== ' ' ?
              <CampoRenglon estiloBox={{display: "flex"}} titulo="Descripción" campo={orden.Descr}
                estiloTitulo={{color: colorTitulo, fontWeight: 700, paddingRight: 0.2 + 'rem'}}
              />
            : null}                    
          </CardContent>                     
        </Card>
      </Box>                    
     <MenuTab listArchivos={listArchivos} contrato={contrato} llenarListFile={llenarListFile} 
        getListMaquinaria={getListMaquinaria} listMaquinaria={listMaquinaria}
      />     
    </span>)
  }

   const onChangeDate=(e)=>{
    if (e.target.value!=="" && e.target.value!==null && e.target.value!==undefined 
      
    ) {
      if (e.target.value.length===10 && parseInt(e.target.value.substring(0,4 ))>=1900  ) 
      {        
        setFiltro({...filtro,[e.target.name] : e.target.value})                   
      }      
    }
    
  }  

  const selectTipo= <FormControl style={{   width: "10rem" ,marginRight:1+'rem'}} size="small">
  <InputLabel id="demo-select-small" variant='outlined' >Tipo</InputLabel>
  <Select
    labelId="demo-select-small" id="demo-select-small" name="tipo"
    value={tipo} label="Tipo" onChange={onChaneTipo}  variant='outlined'
  >      
    {listTipo.map((tipo)=> {
      
        return<MenuItem value={tipo.Id}>{tipo.Descr}</MenuItem>    
     
    })}
  </Select>
</FormControl>

  const modalAsegura = modAsegura? <ModalNvoAseguradra modalAbierto={modAsegura} setModalAbierto={setModAsegura} registro={[]} Buscar={()=>{}} />:null
  return (
  <Box style={{ padding:0,margin:0}} >
    {modalAsegura}
    <Card  style={{ padding:0,margin:0}} >
      <CardContent style={{paddingBottom:".5rem",padding:0,alignContent:"center"}}  >
        <Box display="flex" flexDirection="row" style={{marginTop:.7+'rem', alignContent:"center"}} mb={1}  >                                                                      
          <Box pr={1} >
          <Tooltip title="Buscar">
            <IconButton color="primary"  aria-label="add circle" size="small"
              component="span" onClick={Buscar}
            >
              <SearchIcon/>
            </IconButton>         
          </Tooltip>                                                                                                                     
          </Box>                                         
          <Box display={"flex"} style={{alignContent:"center" }} >
            { listTipo.length!==0 ? selectTipo  :null  }                                                      
          </Box>
          <FormControlLabel
              control={<Checkbox checked={Vigente} onChange={onChangeCheck} name="Vigente" />}
              label="Vigente"  
            />
            <Button size="small" variant="outlined" onClick={()=>setModAsegura(true)}>Nueva Aseguradora</Button>             
        </Box>    
                                                                                                         
      </CardContent>                                
    </Card>
  
    <Box display="flex" flexDirection="row"   style={{marginTop:.2+'rem'}}>
      <Box style={{marginRight:.5+'rem',}}>
        {  espera && listSeguro.length ===0 ?
          <Box  style={{ width: '100%' ,marginTop:2+'rem'}}><LinearProgress/></Box>
        : <TablaSeguro datos={listSeguro} setContrato={setContrato} Buscar={Buscar} />  }
      </Box>  
      <Box style={{marginLeft:"1rem"}}>
        { contrato.length!==0 ? 
          costadoDerecho(contrato)
         /*  <MenuTab listArchivos={listArchivos} contrato={contrato} llenarListFile={llenarListFile} 
            getListMaquinaria={getListMaquinaria} listMaquinaria={listMaquinaria}
          /> */
        :null}

        {/* contrato.length!==0 ? menu() :null}
        { opcion===1 && findNumberCad('|40|',cadena) ?
          (  esperaArch   ? 
              <Box style={{ width: '100%' ,marginTop:2+'rem'}}><LinearProgress/></Box>
            : (contrato.length!==0  ?
              <TablaArchivos datos={listArchivos} contrato={contrato}  llenarListFile={llenarListFile} />            
              :null)
          )
          :null
        }
        { opcion===2 ?
          (  esperaArch   ? 
              <Box style={{ width: '100%' ,marginTop:2+'rem'}}><LinearProgress/></Box>
            : (contrato.length!==0  ?
              <TablaMaquinaria datos={listMaquinaria} contrato={contrato}  llenarListFile={getListMaquinaria} />            
              :null)
          )
          :null */
        }
      </Box>  
    </Box>
  </Box> 
  )
}

export default Seguro